import { Controller } from "@hotwired/stimulus"

// Sets element text based on the browser's local time of day.
// Provide morning/afternoon/evening values; the matching one is applied on connect.
//
// Example:
//   <p data-controller="time-of-day"
//      data-time-of-day-morning-value="Good morning, Nick"
//      data-time-of-day-afternoon-value="Good afternoon, Nick"
//      data-time-of-day-evening-value="Good evening, Nick">Good morning, Nick</p>
export default class extends Controller {
  static values = {
    morning: String,
    afternoon: String,
    evening: String
  }

  connect() {
    const h = new Date().getHours()
    const text = h < 12 ? this.morningValue : h < 18 ? this.afternoonValue : this.eveningValue
    if (text) this.element.textContent = text
  }
}
